import React from "react"
import { Col, Modal, ModalBody, Row } from "reactstrap"
import Products from "./Products/Products"
import KeywordsTable from "./KeywordsTable/KeywordsTable"

const AddKeywordsAndBidsModal = ({ isModalOpen, setIsModalOpen }) => {

  const toggle = () => setIsModalOpen(!isModalOpen)

  return (
    <div>
      <Modal
        isOpen={isModalOpen}
        toggle={toggle}
centered
size="xl"
      >
        <ModalBody>
          <div className="fw-semibold fs-4">Add Keywords and Bid</div>


          <Row>
            <Col xs='4'>
              <Products />
            </Col>
            <Col xs='8'>
              <KeywordsTable />
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default AddKeywordsAndBidsModal
